import React, { useState } from "react";
import  { useDetectClickOutside }  from "react-detect-click-outside";
import "../../features.common.styles.scss";
import PropTypes from 'prop-types';

const TableActions = (props) => {
  const { onGetLimit, limit: currentLimit } = props;
  const [state, setState] = useState({
    show: false,
  });
  const ref = useDetectClickOutside({
    onTriggered: () =>
      setState({
        show: false,
      }),
  });
  
  return (
    <div className={props?.headerBtn ? "filternav" : "filternav toolnav"}>
      {props?.headerBtn && props?.headerBtn()}
      <div
        className="pagecount"
        style={props?.headerBtn ? { width: props.headerBtnWidth } : {}}
      >
        <div className="frmgroup">
          <label className="pagination_rowPerPage">Rows per page   </label>
          <div className="dropdown bootstrap-select" ref={ref}>
            <button
              type="button"
              tabIndex="-1"
              className="btn dropdown-toggle bs-placeholder btn-light"
              data-bs-toggle="dropdown"
              onClick={() => setState({ ...state, show: !state.show })}
            >
              <div className="filter-option">
                <div className="filter-option-inner">
                  <div className="filter-option-inner-inner">
                    {currentLimit}
                  </div>
                </div>
              </div>
            </button>
            <div className={`dropdown-menu ${state.show ? "show" : ""}`}>
              <div className="inner show" tabIndex="-1">
                <ul className="dropdown-menu inner show">
                  {[10, 20, 50, 100].map((limit, index) => (
                    <li className="selected active" key={ index }>
                      <a
                        className={
                          currentLimit === limit
                            ? "dropdown-item active selected"
                            : "dropdown-item"
                        }
                        tabIndex="0"
                        onClick={() => {
                          onGetLimit(parseInt(limit));
                          setState({ ...state, show: !state.show });
                        }}
                      >
                        <span className="text">{limit}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TableActions.propTypes = {
  onGetLimit: PropTypes.func.isRequired,          
  limit: PropTypes.number.isRequired,              
  headerBtn: PropTypes.func,                       
  headerBtnWidth: PropTypes.oneOfType([          
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default TableActions;



